export const BaseURL = `https://scoringapi.codechallenge-championship.org`;

export const loginURL = `${BaseURL}/judge/dashboard/login`;
export const logoutURL = `${BaseURL}/judge/dashboard/logout`;
export const userInfo = `${BaseURL}/judge/dashboard/loggedInInfo`;
export const categoriesURL = `${BaseURL}/judge/dashboard/categories`;
export const ageGroupsURL = `${BaseURL}/judge/dashboard/ageGroups`;
export const teamsURL = `${BaseURL}/judge/dashboard/teams`;
export const missionsURL = `${BaseURL}/judge/dashboard/missions`;
export const judgesURL = `${BaseURL}/judge/dashboard/judges`;
export const missionJudgingURL = `${BaseURL}/judge/dashboard/missionJudgings`;
export const activateURL = `${BaseURL}/judge/dashboard/activate`;
